import { CollectionsListState } from '@src/types/Collection';

export function areCategoryListsEqual(
  a: CollectionsListState = [],
  b: CollectionsListState = []
): boolean {
  if (a === b) {
    return true;
  }
  if (!a || !b || a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i += 1) {
    const currentA = a[i];
    const currentB = b[i];
    if (!currentB || currentA.name !== currentB.name) {
      return false;
    }
    const listA = currentA.list;
    const listB = currentB.list;
    if (listA.length !== listB.length) {
      return false;
    }
    for (let j = 0; j < listA.length; j += 1) {
      if (listA[j] !== listB[j]) {
        return false;
      }
    }
  }
  return true;
}
